module.exports = __webpack_public_path__ + "img/10_25.629e915b.png";